import snackbarError from "../snackbarError";

export default {
  mixins: [snackbarError],
  data: () => ({
    error: "",
    messages: {}
  }),
  methods: {
    transportError(error) {
      if (!error.response) {
        this.error = "Непредвиденная ошибка";
        return;
      }

      const status = +error.response.status;

      if (status > 400 && status < 500) {
        this.error = status + " Непредвиденная ошибка";
      }

      switch (status) {
        case 400:
          this.error = status + " Ошибка клиента";
          break;
        case 401:
        case 403:
          this.$router.push({ name: "Logout" });
          break;
        case 404:
          this.error = status + " Узел не найден";
          break;
        case 429:
          this.error = status + " Слишком много запросов на сервер";
      }

      if (status >= 500) {
        this.error = status + " Ошибка сервера";
      }

      if (error.response.data.message) {
        this.error = status + " " + error.response.data.message;
      }

      if (error.response.data.errors) {
        Object.keys(error.response.data.errors).forEach((key) => {
          this.messages[key] = "";
          for (let i = 0; i < error.response.data.errors[key].length; i++) {
            this.messages[key] += error.response.data.errors[key][i];
            if (i !== error.response.data.errors[key].length - 1) {
              this.messages[key] += " ";
            }
          }
        });
      }
      this.showSnack();
    }
  }
};
